/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.referencias': 'Referencias',
'referencias.agregarReferencias': 'Create Referencias',
'referencias.modificarReferencias': 'Edit Referencias',
'referencias.eliminarReferencias': 'Delete Referencias',
'referencias.referenciaId': 'Referencia   Id ',
'referencias.empresaId': ' Empresa   Id ',
'referencias.referenciaDescripcion': ' Referencia   Descripcion',
'referencias.referencias': 'Referencias',
'referencias.verReferencias': 'View Referencias',
};

